/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type SimCardDetailManageAllowedReasonsItem =
  (typeof SimCardDetailManageAllowedReasonsItem)[keyof typeof SimCardDetailManageAllowedReasonsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SimCardDetailManageAllowedReasonsItem = {
  OPEN_ESIM_RESET: "OPEN_ESIM_RESET",
  OPEN_ESIM_CHANGE: "OPEN_ESIM_CHANGE",
  IS_FIXED_SERVICE_INCOMPLETE: "IS_FIXED_SERVICE_INCOMPLETE",
} as const;
